export default __webpack_public_path__ + "static/media/01.b0b91a77.jpg";